import { createRef } from "react";

export const userFieldRefs = {
  // Personal Details
  firstName: createRef(),
  lastName: createRef(),
  preferredName: createRef(),
  gender: createRef(),
  email: createRef(),
  countryCode: createRef(),
  phone: createRef(),
  address: createRef(),
  city: createRef(),
  state: createRef(),
  zip: createRef(),
  country: createRef(),
  addressConfirmation: createRef(),
  // Emergency Contact
  ecFirstName: createRef(),
  ecLastName: createRef(),
  ecCountryCode: createRef(),
  ecPhone: createRef(),
  ecCountry: createRef(),
  // Passport Information
  Citizenship: createRef(),
  passportNo: createRef(),
  passportExp: createRef(),
  dob: createRef(),
  passportConfirmation: createRef(),
  // Health Details
  medicalIssues: createRef(),
  medications: createRef(),
  allergies: createRef(),
  walkIssue: createRef(),
  carSick: createRef(),
  seaSick: createRef(),
  foodAllergies: createRef(),
  dietaryPreferences: createRef(),
  dietaryPreferencesDetails: createRef(),
  packageOption: createRef(),
  // Air Travel Details
  flightNumber: createRef(),
  departureDate: createRef(),
  airline: createRef(),
  airportFrom: createRef(),
  airportTo: createRef(),
  departureTime: createRef(),
  arrivalDate: createRef(),
  arrivalTime: createRef(),
  flightBoundConfirmation: createRef(),
  // Accommodation Details
  userType: createRef(),
  Cruise: createRef(),
  Category: createRef(),
  isKnownUser: createRef(),
};

export const participantFieldRefs = {
  // Personal Details
  firstName: createRef(),
  lastName: createRef(),
  preferredName: createRef(),
  gender: createRef(),
  email: createRef(),
  countryCode: createRef(),
  phone: createRef(),
  address: createRef(),
  city: createRef(),
  state: createRef(),
  zip: createRef(),
  country: createRef(),
  addressConfirmation: createRef(),
  // Emergency Contact
  ecFirstName: createRef(),
  ecLastName: createRef(),
  ecCountryCode: createRef(),
  ecPhone: createRef(),
  ecCountry: createRef(),
  // Passport Information
  Citizenship: createRef(),
  passportNo: createRef(),
  passportExp: createRef(),
  dob: createRef(),
  passportConfirmation: createRef(),
  // Health Details
  medicalIssues: createRef(),
  medications: createRef(),
  allergies: createRef(),
  walkIssue: createRef(),
  carSick: createRef(),
  seaSick: createRef(),
  foodAllergies: createRef(),
  dietaryPreferences: createRef(),
  dietaryPreferencesDetails: createRef(),
  packageOption: createRef(),
  // Air Travel Details
  flightNumber: createRef(),
  departureDate: createRef(),
  airline: createRef(),
  airportFrom: createRef(),
  airportTo: createRef(),
  departureTime: createRef(),
  arrivalDate: createRef(),
  arrivalTime: createRef(),
  flightBoundConfirmation: createRef(),
  // Accommodation Details
  userType: createRef(),
  Cruise: createRef(),
  Category: createRef(),
  isKnownUser: createRef(),
};
